var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region Reconciliation - Ctor 
    ns.Reconciliation = function Reconciliation($translate, calcSnacksOnlyForPresent) {
        this.attendance = [];
        this.calcSnacksOnlyForPresent = calcSnacksOnlyForPresent;
        // from InvoiceBase
        this.resetFields();
        if ($translate) {
            this.initLocalization($translate);
        }
    }
    // #endregion

    // #region InvoiceBase - Inheritance

    ns.Reconciliation.prototype = new ns.InvoiceBase();
    ns.Reconciliation.prototype.constructor = ns.InvoiceBase;
    ns.Reconciliation.prototype.parent = ns.InvoiceBase.prototype;

    // #endregion

    // #region Reconciliation - Methods

    ns.Reconciliation.prototype.getReconciliationDetailDTO = function ($translate) {
        var res = { reconciliation: {}, attendance: [], invoice: { lineItems: [] } };

        res.reconciliation.activityReconciliationID = this.activityReconciliationID;
        res.reconciliation.studentID = this.studentID;
        res.reconciliation.activityID = this.activityID;
        res.reconciliation.name = this.name;
        res.reconciliation.notes = this.notes;
        res.reconciliation.reconciledAt = this.reconciledAt || new Date();
        res.reconciliation.notificationSentAt = this.notificationSentAt;
        res.reconciliation.tariffFrom = this.tariffFrom;
        res.reconciliation.tariffTo = this.tariffTo;

        res.invoice = this.getInvoiceDTO($translate);

        for (var a = 0; a < this.attendance.length; a++) {
            var att = this.attendance[a];
            if (att.isSelected) {
                res.attendance.push(att.getReconciliationAttendanceDTO.call(att));
            }
        }

        return res;
    }

    ns.Reconciliation.prototype.initData = function (reconciliationDetailDTO) {

        // reconciliation
        this.studentID = reconciliationDetailDTO.reconciliation.studentID;
        this.activityID = reconciliationDetailDTO.reconciliation.activityID;
        this.activityReconciliationID = reconciliationDetailDTO.reconciliation.activityReconciliationID;
        this.name = reconciliationDetailDTO.reconciliation.name;
        this.notes = reconciliationDetailDTO.reconciliation.notes;
        this.reconciledAt = reconciliationDetailDTO.reconciliation.reconciledAt;
        this.notificationSentAt = reconciliationDetailDTO.reconciliation.notificationSentAt;
        this.activity = reconciliationDetailDTO.activity;
        this.activityStudentSetting = reconciliationDetailDTO.activityStudentSetting;
        this.tariffFrom = reconciliationDetailDTO.reconciliation.tariffFrom;
        this.tariffTo = reconciliationDetailDTO.reconciliation.tariffTo;

        this.initDataAttendance(reconciliationDetailDTO);

        if (this.activityStudentSetting && this.activityStudentSetting.tariffPrice) {
            this.invoiceLineKindergartenFeeUnitPrice = this.activityStudentSetting.tariffPrice;
            this.invoiceLineKindergartenFeeQty = this.calculateNoOfPlanedForTariffDays();
        }

        this.initDataByInvoiceDTO(reconciliationDetailDTO.invoice);

        this.initDataActivity(reconciliationDetailDTO);

    }
    
    ns.Reconciliation.prototype.recalculateTariffPrice = function () {
        if (this.activityStudentSetting && this.activityStudentSetting.tariffPrice) {
            this.invoiceLineKindergartenFeeUnitPrice = this.activityStudentSetting.tariffPrice;
            this.invoiceLineKindergartenFeeQty = this.calculateNoOfPlanedForTariffDays();
        }
    }

    ns.Reconciliation.prototype.calculateNoOfPlanedForTariffDays = function() {
        if (this.activityStudentSetting.activityTariffTypeID === 0 ||
            !this.tariffFrom || !this.tariffTo) {
            return 1;
        }

        let mStartDate = moment(this.tariffFrom).subtract(1, 'day').startOf('day');
        let mEndDate = moment(this.tariffTo).add(1, 'day').startOf('day');

        let result = 0;

        for (let a = 0; a < this.attendance.length; a++) {
            let at = this.attendance[a];
            let mAtDate = moment(at.date).startOf('day');

            if (mAtDate.isAfter(mStartDate) && mAtDate.isBefore(mEndDate)) {

                if (at.attendance.firstPeriodRegistered || at.attendance.secondPeriodRegistered) {
                    result++;
                }
            }
        }

        return result;
    }

    ns.Reconciliation.prototype.initDataActivity = function (reconciliationDetailDTO) {
        if (!reconciliationDetailDTO.invoice || !reconciliationDetailDTO.invoice.invoiceID || reconciliationDetailDTO.invoice.invoiceID == "0") {
            this.invoiceLineKindergartenLunchUnitPrice = reconciliationDetailDTO.activity.defaultLunchPrice || 0;
            this.invoiceLineKindergartenSnackUnitPrice = reconciliationDetailDTO.activity.defaultSnackPrice || 0;
            this.invoiceLineKindergartenLatePickupUnitPrice = reconciliationDetailDTO.activity.defaultLatePickupPrice || 0;
        }
    }

    ns.Reconciliation.prototype.initDataAttendance = function (reconciliationDetailDTO) {
        var att = [];
        for (var i = 0; i < reconciliationDetailDTO.attendance.length; i++) {
            var amodel = new webooker_acivity_models.ReconciliationAttendance(reconciliationDetailDTO.attendance[i], this.activityReconciliationID, this.calcSnacksOnlyForPresent);
            att.push(amodel);
            if (this.activityReconciliationID && this.activityReconciliationID === amodel.attendance.activityReconciliationID) {
                amodel.isSelected = true;
            } else {
                amodel.isSelected = false;
            }
        }
        this.attendance.push.apply(this.attendance, att);
    }


    // #region Reconciliation - Properties

    Object.defineProperty(ns.Reconciliation.prototype, 'noOfLunches', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected && a.lunch === '\u2713') {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'noFirstSnacks', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected && a.firstSnack === '\u2713') {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'noSecondSnacks', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected && a.secondSnack === '\u2713') {
                    count++;
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'fullDayRegisteredAttendance', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.firstPeriodRegistered && a.attendance.secondPeriodRegistered) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'shortDayRegisteredAttendance', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.firstPeriodRegistered &&
                    a.attendance.secondPeriodRegistered &&
                    a.attendance.secondPeriodAttendanceShortened) {
                    count++;
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodOnlyRegisteredAttendance', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.firstPeriodRegistered &&
                    !a.attendance.secondPeriodRegistered) {
                    count++;
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodOnlyRegisteredAttendance', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    !a.attendance.firstPeriodRegistered &&
                    a.attendance.secondPeriodRegistered) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'fullDayActualAttendanceNoOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (((a.attendance.firstPeriodAttendanceTypeID == 0 &&
                         a.attendance.firstPeriodRegistered) || (a.attendance.firstPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3) &&
                        ((a.attendance.secondPeriodAttendanceTypeID == 0 && 
                         a.attendance.secondPeriodRegistered) || (a.attendance.secondPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                         a.attendance.secondPeriodAttendanceStatusID == 1 ||
                         a.attendance.secondPeriodAttendanceStatusID == 3)) {
                        count++;
                    }
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'shortDayActualAttendanceNoOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (((a.attendance.firstPeriodAttendanceTypeID == 0 &&
                         a.attendance.firstPeriodRegistered) || (a.attendance.firstPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3) &&
                        ((a.attendance.secondPeriodAttendanceTypeID == 0 &&
                         a.attendance.secondPeriodRegistered) || (a.attendance.secondPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                         a.attendance.secondPeriodAttendanceStatusID == 1 ||
                         a.attendance.secondPeriodAttendanceStatusID == 3) &&
                        a.attendance.secondPeriodAttendanceShortened) {
                        count++;
                    }
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodOnlyActualAttendanceNoOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if ((((a.attendance.firstPeriodAttendanceTypeID == 0 &&
                         a.attendance.firstPeriodRegistered) || (a.attendance.firstPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3)) &&
                        !(((a.attendance.secondPeriodAttendanceTypeID == 0 &&
                         a.attendance.secondPeriodRegistered) || (a.attendance.secondPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                         a.attendance.secondPeriodAttendanceStatusID == 1 ||
                         a.attendance.secondPeriodAttendanceStatusID == 3))) {
                        count++;
                    }
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodOnlyActualAttendanceNoOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (!(((a.attendance.firstPeriodAttendanceTypeID == 0 &&
                         a.attendance.firstPeriodRegistered) || (a.attendance.firstPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3)) &&
                        (((a.attendance.secondPeriodAttendanceTypeID == 0 &&
                         a.attendance.secondPeriodRegistered) || (a.attendance.secondPeriodAttendanceTypeID == 2)) &&
                        (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                         a.attendance.secondPeriodAttendanceStatusID == 1 ||
                         a.attendance.secondPeriodAttendanceStatusID == 3))) {
                        count++;
                    }
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'fullDayOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (a.attendance.firstPeriodAttendanceTypeID == 1 &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3) &&
                        a.attendance.secondPeriodAttendanceTypeID == 1 &&
                        (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                         a.attendance.secondPeriodAttendanceStatusID == 1 ||
                         a.attendance.secondPeriodAttendanceStatusID == 3)) {
                        count++;
                    }
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'shortDayOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (a.attendance.firstPeriodAttendanceTypeID == 1 &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3) &&
                        a.attendance.secondPeriodAttendanceTypeID == 1 &&
                        (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                         a.attendance.secondPeriodAttendanceStatusID == 1 ||
                         a.attendance.secondPeriodAttendanceStatusID == 3) &&
                         a.attendance.secondPeriodAttendanceShortened) {
                        count++;
                    }
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodOnlyOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (a.attendance.firstPeriodAttendanceTypeID == 1 &&
                        (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                         a.attendance.firstPeriodAttendanceStatusID == 1 ||
                         a.attendance.firstPeriodAttendanceStatusID == 3) &&
                       !(a.attendance.secondPeriodAttendanceTypeID == 1 &&
                         (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                          a.attendance.secondPeriodAttendanceStatusID == 1 ||
                          a.attendance.secondPeriodAttendanceStatusID == 3))) {
                        count++;
                    }
                }

            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodOnlyOneOffs', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    if (!(a.attendance.firstPeriodAttendanceTypeID == 1 &&
                         (a.attendance.firstPeriodAttendanceStatusID == 0 ||
                          a.attendance.firstPeriodAttendanceStatusID == 1 ||
                          a.attendance.firstPeriodAttendanceStatusID == 3)) &&
                         (a.attendance.secondPeriodAttendanceTypeID == 1 &&
                          (a.attendance.secondPeriodAttendanceStatusID == 0 ||
                           a.attendance.secondPeriodAttendanceStatusID == 1 ||
                           a.attendance.secondPeriodAttendanceStatusID == 3))) {
                        count++;
                    }
                }

            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodLatePickupHours', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    count += a.attendance.firstPeriodLatePickupHours;
                }

            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodLatePickupHours', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    count += a.attendance.secondPeriodLatePickupHours;
                }

            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'sumLatePickupHours', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    count += a.attendance.firstPeriodLatePickupHours;
                    count += a.attendance.secondPeriodLatePickupHours;
                }

            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodExcuses', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&                    
                    a.attendance.firstPeriodAttendanceStatusID == 2) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodExcuses', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.secondPeriodAttendanceStatusID == 2) {
                    count++;
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodExcusesWithoutFood', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.firstPeriodAttendanceStatusID == 4) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodExcusesWithoutFood', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.secondPeriodAttendanceStatusID == 4) {
                    count++;
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodExcusesNoComp', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.firstPeriodAttendanceStatusID == 3) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodExcusesNoComp', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected &&
                    a.attendance.secondPeriodAttendanceStatusID == 3) {
                    count++;
                }
            }
            return count;
        }
    });


    Object.defineProperty(ns.Reconciliation.prototype, 'firstPeriodNotExcused', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if ((a.isSelected && a.attendance.firstPeriodAttendanceStatusID == 1) &&
                     !(a.attendance.firstPeriodAttendanceTypeID == 0 && !a.attendance.firstPeriodRegistered)) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'secondPeriodNotExcused', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if ((a.isSelected && a.attendance.secondPeriodAttendanceStatusID == 1) &&
                     !(a.attendance.secondPeriodAttendanceTypeID == 0 && !a.attendance.secondPeriodRegistered)) {
                    count++;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'noOfMinutes', {
        enumerable: true, configurable: true,
        get: function () {
            var count = 0;
            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];

                if (a.isSelected) {
                    count = count + a.noOfMinutes;
                }
            }
            return count;
        }
    });

    Object.defineProperty(ns.Reconciliation.prototype, 'noOfMinutesStr', {
        enumerable: true, configurable: true,
        get: function () {
            var minutesOrig = this.noOfMinutes;

            var hours = Math.floor(minutesOrig / 60);
            var minutes = Math.floor(minutesOrig - (hours * 60));

            if (minutes === 0) {
                return hours;
            }

            if (minutes < 10) {
                return hours + ':0' + minutes;
            }

            return hours + ':' + minutes;
        }
    });

    // #endregion

    // #region Utility properties


    Object.defineProperty(ns.Reconciliation.prototype, 'isAnythingSelected', {
        enumerable: true, configurable: true,
        get: function () {

            for (var i = 0; i < this.attendance.length; i++) {
                var a = this.attendance[i];
                if (a.isSelected) {
                    return true;
                }
            }

            return false;
        }
    });

    // #endregion

}(webooker_acivity_models));